import React from "react"

import "./App.scss"
import Quiz from "@Quiz"

import { WithApi } from "@api"
import QuizEmbedInfoContext, { EMBED_INFO_CONTEXT_SZ_ON_SEPARATE_PAGE } from "@Quiz/QuizEmbedInfoContext"

interface AppRawProps {
  quizUid?: string
}

export const AppRaw: React.FC<AppRawProps> = ({ quizUid }) => {
  return quizUid
    ? <QuizEmbedInfoContext.Provider value={EMBED_INFO_CONTEXT_SZ_ON_SEPARATE_PAGE}>
        <Quiz quizUid={quizUid} forceMode="light" />
      </QuizEmbedInfoContext.Provider>
    : <div />
}

interface AppProps {
  apiPath: string
}

const App: React.FC<AppProps & AppRawProps> = ({ quizUid, apiPath }) => {
  return (
    <div className="neo__app">
      <WithApi apiEndpoint={apiPath} locale="de">
        <AppRaw quizUid={quizUid} />
      </WithApi>
    </div>
  )
}

export default App
